<template>
  <OffSetDefault id="offset-historicos" title="Historicos" size="lg">
      <template #body>
        <div class="p-4">
          <HistorialInfo
            :persona="persona"
            :technologias="technologias"
          />
        </div>
      </template>
    </OffSetDefault>
</template>
<script setup lang="ts">
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import type { IConfPersonasPaciente } from '@/modules/Administracion/interfaces'

defineProps<{
  persona: IConfPersonasPaciente
  technologias?: ICitaTechnologiasSalud[]
}>()
</script>
